// extracted by mini-css-extract-plugin
export default {"videoContainer":"styles_videoContainer__ZAyBc","video":"styles_video__TTq7d"};